import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SpinnerService {
    private spinners: any[] = [];
    private spinner: HTMLDivElement;
    constructor() {
    }
    init(spinnerid: string) {
        this.spinner = document.getElementById(spinnerid) as HTMLDivElement;
    }
    show() {
        let id = (Math.random() * 100000000) + Date.now() + "spinner";
        this.spinners.push({ id });
        this.checkDisp();
        return id;
    }

    hide() {
        this.spinners.pop();
        this.checkDisp();
    }
    hideAll() {
        this.spinners = [];
        this.checkDisp();
    }
    checkDisp() {
        this.spinner.style.display = this.spinners.length ? 'block' : 'none';
    }
}
